function LeadForm() {
  return (
    <form className="card p-5 sm:p-6">
      <div className="grid gap-4">
        <div className="grid gap-4 sm:grid-cols-2">
          <label className="grid gap-1.5 text-sm font-medium text-slate-200">
            Jmeno
            <input className="input" placeholder="Jan Novak" />
          </label>
          <label className="grid gap-1.5 text-sm font-medium text-slate-200">
            Telefon
            <input className="input" placeholder="+420 123 456 789" />
          </label>
        </div>
        <label className="grid gap-1.5 text-sm font-medium text-slate-200">
          E-mail
          <input className="input" placeholder="jan@email.cz" />
        </label>
        <label className="grid gap-1.5 text-sm font-medium text-slate-200">
          Typ prace
          <select className="input">
            <option>Vyberte typ zakazky</option>
            <option>Elektroinstalace</option>
            <option>Rekonstrukce</option>
            <option>Revize</option>
            <option>Datove rozvody</option>
          </select>
        </label>
        <label className="grid gap-1.5 text-sm font-medium text-slate-200">
          Popis
          <textarea className="textarea" placeholder="Strucne popiste, co potrebujete vyresit." />
        </label>
        <button type="button" className="btn-primary w-full sm:w-auto">
          Odeslat poptavku
        </button>
      </div>
    </form>
  );
}

export default LeadForm;
